




import Component from "vue-class-component";
import InitCompanyComponent from '@/components/InitCompany.vue';
import { Base } from '@/base';

@Component({
  name: 'InitCompanyPage',
  components: {
    InitCompanyComponent
  }
})
export default class InitCompanyPage extends Base {
};
